module.exports = __webpack_public_path__ + "static/media/streamline-plump_web.3d170951.svg";